import {useRuntimeConfig} from "nuxt/app";

export const useApiBase = function (uri) {
    const config = useRuntimeConfig()
    if (!uri.startsWith('/'))
        uri = '/' + uri

    return `${config.public.apiBase}${uri}`
}
